import { Units } from '../../../lib/charts/saleChartsTypes';
import { useAppDispatch } from '../../../store';
import { setChartUnit } from '../detailSlice';
import { DetailType } from '../detailTypes';
import { useCallback } from 'react';

export type SetDefaultChartUnitFunction = (detailType: DetailType) => void;

/**
 * Set the default chart unit based on the detail type.
 * CATEGORY -> VALUE
 * PRODUCT, SKU -> QUANTITY
 * @returns A function that sets the default chart unit based on the detail type.
 */
const useSetDefaultChartUnit = (): SetDefaultChartUnitFunction => {
  const dispatch = useAppDispatch();

  return useCallback(
    (detailType: DetailType) => {
      switch (detailType) {
        case DetailType.CATEGORY:
          dispatch(setChartUnit(Units.VALUE));
          break;
        case DetailType.PRODUCT:
        case DetailType.SKU:
        case DetailType.SKU_NOT_FOUND:
          dispatch(setChartUnit(Units.QUANTITY));
          break;
      }
    },
    [dispatch],
  );
};

export default useSetDefaultChartUnit;
